import { render, staticRenderFns } from "./Allocation.vue?vue&type=template&id=3132aeb1&"
import script from "./Allocation.vue?vue&type=script&lang=js&"
export * from "./Allocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports